import { useEffect, useState } from 'react';
import { authApi, type PBXPublicConfig } from '../../lib/api';

export function usePublicConfig(): PBXPublicConfig | undefined {
	const [pbxConfig, setPbxConfig] = useState<PBXPublicConfig | undefined>();

	useEffect(() => {
		let cancelled = false;
		const fetch = async () => {
			try {
				const config = await authApi.publicConfig();
				if (!cancelled && config.pbx) {
					setPbxConfig(config.pbx);
				}
			} catch {
				// Silently fail — PBX features just won't activate
			}
		};
		void fetch();
		return () => {
			cancelled = true;
		};
	}, []);

	return pbxConfig;
}
